var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "work",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 37.52,
    y1: 89.08,
    x2: 86.43,
    y2: 19.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#09ff83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#21ff8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#49ff97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64ffa0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.65,105.6,44.2,122.4H39.11L35.9,112.18,32.54,122.4H27.45L22,105.6h4.9l3.38,10.73,3.55-10.73H38.2l3.38,10.82,3.53-10.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.82,121.61a8.44,8.44,0,0,1-3.34-3.12,8.94,8.94,0,0,1,0-9,8.44,8.44,0,0,1,3.34-3.12,10.72,10.72,0,0,1,9.58,0,8.6,8.6,0,0,1,0,15.22,10.72,10.72,0,0,1-9.58,0Zm7.09-3.41a4.28,4.28,0,0,0,1.63-1.69,5.55,5.55,0,0,0,0-5,4.28,4.28,0,0,0-1.63-1.69,4.73,4.73,0,0,0-4.61,0,4.35,4.35,0,0,0-1.63,1.69,5.55,5.55,0,0,0,0,5,4.35,4.35,0,0,0,1.63,1.69,4.73,4.73,0,0,0,4.61,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.78,117.94H76.19v4.46H71.44V105.6h7.68a9.49,9.49,0,0,1,4,.76,5.89,5.89,0,0,1,.22,10.76l3.62,5.28H81.83ZM81,110a3.29,3.29,0,0,0-2.21-.65H76.19v4.92h2.64a3.35,3.35,0,0,0,2.21-.63,2.25,2.25,0,0,0,.74-1.81A2.28,2.28,0,0,0,81,110Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.68,116.3l-1.78,1.9v4.2H89.2V105.6h4.7v7l6.51-7h5.23L98.78,113,106,122.4h-5.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124,29.43V17.26H69l-12-12H4v67l8-8v-51H52L63.92,25.19,4,85.24v12H124V42.4l-8,8V89.26H64.16ZM52,89.26H12l64-64h40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.ff14a96f8a002608e70087e0e8ee3adc.svg";
export { ForwardRef as ReactComponent };